import { Suspense, lazy } from "react";
import PublicRoute from "./PublicRoute";
import PageLoader from "../components/PageLoader";
const ForgotPassword = lazy(() => import("../modules/auth/ForgotPassword"));
const Login = lazy(() => import("../modules/auth/Login"));
const ResetPassowrd = lazy(() => import("../modules/auth/ResetPassword"));
const CompanyRegistration = lazy(() =>
  import("../modules/auth/CompanyRegistration")
);
const CreateUserAccount = lazy(() =>
  import("../modules/auth/CreateUserAccount")
);
const VerifyEmail = lazy(() => import("../modules/auth/verifyEmail"));
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));

const AuthRoutes = [
  {
    path: "/login",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PublicRoute>
          <Login />
        </PublicRoute>
      </Suspense>
    ),
  },
  {
    path: "/terms",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PublicRoute>
          <TermsAndConditions />
        </PublicRoute>
      </Suspense>
    ),
  },
  {
    path: "/forgot-password",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      </Suspense>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PublicRoute>
          <ResetPassowrd />
        </PublicRoute>
      </Suspense>
    ),
  },
  {
    path: "/sign-up",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PublicRoute>
          <CreateUserAccount />
        </PublicRoute>
      </Suspense>
    ),
  },
  {
    path: "/verify-email",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PublicRoute>
          <VerifyEmail />
        </PublicRoute>
      </Suspense>
    ),
  },
  {
    path: "/company-register",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PublicRoute>
          <CompanyRegistration />
        </PublicRoute>
      </Suspense>
    ),
  },
];
export default AuthRoutes;
